import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lecture-import',
  templateUrl: './lecture-import.component.html',
  styleUrls: ['./lecture-import.component.scss']
})
export class LectureImportComponent implements OnInit {

  constructor() {  }

  ngOnInit() {
  }

}
